import { useEffect, useState } from 'react';
import { ConstructiveProjectServices, IConstructiveProject } from '../../../services/api/constructive-project/ConstructiveProjectServices';
import { ConstructiveStepsServices, IConstructiveSteps } from '../../../services/api/constructive-project/ConstructiveStepsServices';
import { ExpandMoreOutlined } from '@mui/icons-material';
import { Accordion, AccordionSummary, Typography, AccordionDetails, Box, Divider, useTheme } from '@mui/material';

interface ProjetcConsolidatedProps {
    uuid: string | undefined
}

export const ProjetcConsolidated = ({uuid}: ProjetcConsolidatedProps) => {

    const theme = useTheme();
    const [ dataProject, setDataProject ] = useState<IConstructiveProject>();
    const [ dataStep, setDataStep ] = useState<IConstructiveSteps[]>([]);

    useEffect(() => {
        fetchData();
    }, [uuid]);

    const fetchData = () => {
        if(uuid){
            ConstructiveProjectServices.get(uuid, false)
                .then(response => {
                    if(response instanceof Error){
                        console.log(response.message);
                    }else{
                        setDataProject(response);
                        if(response.uuid){
                            ConstructiveStepsServices.get(response.uuid)
                                .then(response => {
                                    if(response instanceof Error){
                                        console.log(response.message);
                                    }else{
                                        setDataStep(response);
                                    }
                                });
                        }
                    }
                });
        }
    };

    if(dataProject == undefined){
        return(null);
    }

    return(
        <>
        <Accordion
            variant='outlined'
            square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
        >
            <AccordionSummary
                expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
            >
                <Typography><strong>Projeto e construção</strong></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Método construtivo: </Typography>
                    <Typography>{dataProject?.metodo_construtivo}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Quantidade de etapas previstas: </Typography>
                    <Typography>{dataProject?.quantidade_etapas_previstas}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Quantidade de etapas executadas: </Typography>
                    <Typography>{dataProject?.quantidade_etapas_executadas}</Typography>
                </Box>
                <Divider/>
            </AccordionDetails>
        </Accordion>
        {dataStep.map((item, index) => (
            <Accordion
                variant='outlined'
                square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                key={item.uuid}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
                >
                    <Typography><strong>Etapa construtiva {index + 1}</strong></Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                        <Typography>Elevaçao (m): </Typography>
                        <Typography>{item.elevacao}</Typography>
                    </Box>
                    <Divider/>
                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                        <Typography>Ano de construçao: </Typography>
                        <Typography>{item.ano_construcao}</Typography>
                    </Box>
                    <Divider/>
                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                        <Typography>Empresa projetista: </Typography>
                        <Typography>{item.empresa_projetista}</Typography>
                    </Box>
                    <Divider/>
                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                        <Typography>Empresa construtora: </Typography>
                        <Typography>{item.empresa_construtora}</Typography>
                    </Box>
                    <Divider/>
                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                        <Typography>Empresa fiscalizadora: </Typography>
                        <Typography>{item.empresa_fiscalizadora_ato}</Typography>
                    </Box>
                    <Divider/>
                </AccordionDetails>
            </Accordion>
        ))}
        </>
    );
};